// ─── Shared Google Maps Loader Config ───────────────────────────────────────
// IMPORTANT: This file must be the single source of truth for the Maps API key
// and libraries. Both Location.tsx and ProfilePage.tsx must import from here to
// avoid the "Loader must not be called again with different options" error.

import { Library } from '@googlemaps/js-api-loader';

// Read the env var (CRA injects these at build time). Keep as undefined|string
// so we can warn at runtime if it's missing.
export const GOOGLE_MAPS_API_KEY: string | undefined = "AIzaSyD0PD9OL2p1Gne4CFOqS9MyL5a6vhWu1MY";

// Must be defined OUTSIDE of any component (never inside a React function) to
// prevent array identity changing on each render — which causes the Loader error.
export const GOOGLE_MAPS_LIBRARIES: Library[] = ['places'];

if (typeof window !== 'undefined') {
  if (!GOOGLE_MAPS_API_KEY) {
    // Helpful warning for developers when env isn't injected / server wasn't restarted
    // eslint-disable-next-line no-console
    console.warn('[googleMapsConfig] REACT_APP_GOOGLE_MAPS_API_KEY is not defined. Google Maps may fail to load.');
  } else {
    // eslint-disable-next-line no-console
    console.debug('[googleMapsConfig] Google Maps API key is set.');
  }
}

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'google-map-script',
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
